const getDefaultStateRendicontiPromoter = () => {
  return {
    cognomeRendicontiPromoter: null,
    meseRendicontiPromoter: null,
    annoRendicontiPromoter: null,
    rowsToSkipRendicontiPromoter: 0,
    fetchRowsRendicontiPromoter: 25,
    currentPageRendicontiPromoter: 1,
    sortColumnRendicontiPromoter: "id_persona",
    sortOrderRendicontiPromoter: "asc",
  };
};
const state = getDefaultStateRendicontiPromoter();

const getters = {
  cognomeRendicontiPromoter: (state) => state.cognomeRendicontiPromoter,
  annoRendicontiPromoter: (state) => state.annoRendicontiPromoter,
  meseRendicontiPromoter: (state) => state.meseRendicontiPromoter,
  rowsToSkipRendicontiPromoter: (state) => state.rowsToSkipRendicontiPromoter,
  fetchRowsRendicontiPromoter: (state) => state.fetchRowsRendicontiPromoter,
  currentPageRendicontiPromoter: (state) => state.currentPageRendicontiPromoter,
  sortColumnRendicontiPromoter: (state) => state.sortColumnRendicontiPromoter,
  sortOrderRendicontiPromoter: (state) => state.sortOrderRendicontiPromoter,
};

// const actions = {};
const mutations = {
  setCognomeRendicontiPromoter: (state, value) => {
    state.cognomeRendicontiPromoter = value;
  },
  setAnnoRendicontiPromoter: (state, value) => {
    state.annoRendicontiPromoter = value;
  },
  setMeseRendicontiPromoter: (state, value) => {
    state.meseRendicontiPromoter = value;
  },
  setFetchRowsRendicontiPromoter: (state, value) => {
    state.currentPageRendicontiPromoter = 1;
    state.rowsToSkipRendicontiPromoter = 0;
    state.fetchRowsRendicontiPromoter = value;
  },
  setCurrentPageRendicontiPromoter: (state, value) => {
    state.currentPageRendicontiPromoter = value;
    state.rowsToSkipRendicontiPromoter = parseInt(
      (state.currentPageRendicontiPromoter - 1) *
        state.fetchRowsRendicontiPromoter
    );
  },
  setSortColumnRendicontiPromoter: (state, value) => {
    state.sortColumnRendicontiPromoter = value;
  },
  setSortOrderRendicontiPromoter: (state, value) => {
    state.sortOrderRendicontiPromoter = value;
  },
  setCategoriaRendicontiPromoter: (state, value) => {
    state.id_categoriaRendicontiPromoter = value;
  },
  resetFiltersRendicontiPromoter: (state) => {
    Object.assign(state, getDefaultStateRendicontiPromoter());
  },
  resetRowsToSkipRendicontiPromoter: (state) => {
    state.currentPageRendicontiPromoter = 1;
    state.rowsToSkipRendicontiPromoter = 0;
  },
};

export default {
  state,
  getters,
  mutations,
};
